module.exports = __webpack_public_path__ + "static/img/channel.10.60eb335.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/channel.10.png
// module id = 218
// module chunks = 131 363 364